const MAP_MODES = {
	CHOROPLETH: 'CHOROPLETH',
};

export const DEFAULT_MODE = MAP_MODES.CHOROPLETH;

export default MAP_MODES;
